import { ReactElement } from 'react';

import { DocplannerIcon, IconSize, IconWrapper, PatientPortalIcon } from '@dreryk/react-components';

import { createAppointmentSourceVisitor } from '~libs.shared.appointments';

type VisitSourceCellProps = {
   readonly sourceLabel: string | undefined;
};

export const VisitSourceCell = (props: VisitSourceCellProps): JSX.Element | null => {
   if (!props.sourceLabel) {
      return null;
   }

   return (
      <IconWrapper testId={props.sourceLabel} size={IconSize.SMALLEST}>
         {createAppointmentSourceVisitor<ReactElement | null>(props.sourceLabel)({
            visitDocplanner: () => <DocplannerIcon />,
            visitPatientPortal: () => <PatientPortalIcon />,
            visitEgabinet: () => null,
         })}
      </IconWrapper>
   );
};
